export default "__VITE_ASSET__YJsvjbq3__"